import Vue from 'vue'
import Router from 'vue-router'
import lazyLoading from './lazyLoading'



import FullLayout from '@layouts/Full'

Vue.use(Router)

const createRouter = () => {
  const routes = [
    {
      path: '',
      component: FullLayout,
      redirect: { name: 'agency.websites.index' },
      children: [
        { name: 'agency.agent', path: 'agentpage/:id', component: lazyLoading('Agency/Pages/AgentaiDesignWrap') }
      ]
    },
    { path: '*', component: lazyLoading('Pages/NotFound') },
   
  ]
  const router = new Router({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
      if (to.hash) return { selector: to.hash }
      else if (savedPosition) return savedPosition
      else return { x: 0, y: 0 }
    }
  })
  return router
}

const router = createRouter()
Router.prototype.resetRouter = function() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router